import { render, staticRenderFns } from "./SpThreeModule1.vue?vue&type=template&id=28451470&scoped=true"
import script from "./SpThreeModule1.vue?vue&type=script&lang=js"
export * from "./SpThreeModule1.vue?vue&type=script&lang=js"
import style0 from "./SpThreeModule1.vue?vue&type=style&index=0&id=28451470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28451470",
  null
  
)

export default component.exports